export default "__VITE_ASSET__DTzmLkJy__"